<template>
  <el-table v-if="cutView=='shipmentOrderItemRecord'|| cutView=='record'" stripe border style="width: 100%; height: 100%" 
    height="100%"  size="mini"
    :data="tableData" @selection-change="handleSelectionChange">
    <el-table-column type="selection" width="39" />
    <el-table-column type="index" align="center"
      :width="pagination.endIndex >= 1000 ? 80 : 50"
      :index="pagination.beginIndex"
    ></el-table-column>
    <el-table-column min-width="120px" v-if="cutView=='shipmentOrderItemRecord'"
      label="交货单号" align="center" prop="allowSkip" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>
          {{ scope.row.likpVbeln ? scope.row.likpVbeln : '-' }}
        </span>
      </template>
    </el-table-column>
    <el-table-column min-width="100px" 
        label="销售单号" align="center" prop="allowSkip" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.lipsVgpos">{{ scope.row.lipsVgbel ? scope.row.lipsVgbel +"-" + scope.row.lipsVgpos : '-' }}</span>
          <span v-else>{{ scope.row.lipsVgbel ? scope.row.lipsVgbel : '-' }}</span>
        </template>
      </el-table-column>
    <el-table-column min-width="120px" v-if="cutView=='shipmentOrderItemRecord'"
      label="客户名称" prop="adrcName1" align="center" show-overflow>
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.adrcName1" :content="scope.row.adrcName1" class="item" effect="dark" placement="top" :open-delay="300">
          <span class="textOverflow">
            {{ scope.row.adrcName1 ? scope.row.adrcName1 : '-' }}
          </span>
        </el-tooltip>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column v-if="cutView=='shipmentOrderItemRecord'"
        label="产品型号" align="center" prop="zc0011" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.zc0011 ? scope.row.zc0011 : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="120px" 
        label="SN" align="center" prop="sn" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.sn ? scope.row.sn : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="发货人" align="center" prop="createUser" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.createUser">
            {{ scope.row.createUser.name }}({{ scope.row.createUser.employeeNum }})
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="发货时间" align="center" prop="createDate" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.createDate}} {{ scope.row.createTime}}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="95px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.status == 0"
            class="item textWarning" effect="dark" content="退货" placement="top" :open-delay="300">
            <i @click="backDevice($event, scope.row)" class="iconfont icon-tuihuo"></i>
          </el-tooltip>
        </template>
      </el-table-column>
  </el-table>
</template>
<script>
import {
  shipmentOrderRecordSearch,shipmentOrderRecordBack,shipmentOrderRecordBatchBack
} from "@/api/SapOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
    cutView:null,
    searchConditionForm:{type: Object},
    pagination:{}
  },
  computed: {
  },
  components: {
  },
  created() {
  },
  data() {
    return {
      dialogTitle: "【未命名】",
      dialogForm: {
      },
      tableData:null,
      dialogRules: {},
      labelWidth: this.$store.state.labelWidth,
      multipleSelection: [],
      OrderIds:[],
      batchDeviceIds: []
    };
  },
  methods: {
       //退货
       backDevice(e, row) {
      e.target.blur();
      const h = this.$createElement;
      const tt = "请输入SN：【";
      const st = row.sn;
      this.$msgbox({
        title: `产品退货`,
        message: h("div", null, [
          h(
            "span",
            null,
            tt
          ),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, `】以确认退货！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await shipmentOrderRecordBack({
          id: row.id,
          sn: row.sn
        });
        if (res.code == 0) {
          this.onSearch()
          this.$message({
            type: "success",
            message: "产品退货成功！"
          });
        }
      });
    },
    //批量退货
    batchBack() {
      this.OrderIds = [];
      this.batchDeviceSns = [];
      let st;
      let _this = this;
      // eslint-disable-next-line no-unused-vars
      let _orderId;
      this.multipleSelection.forEach(function (item){
        _this.OrderIds.push(item.likpVbeln);
        _this.batchDeviceSns.push(item.sn);
        st = item.likpVbeln;
      });

      if(this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "未选择需要锁定的SN号！"
        });
        return;
      }
      _this.OrderIds.some(function (value){
        if(value == _this.OrderIds[0]){
          _orderId = value;
        }else{
          this.$message({
            type: "warning",
            message: "选择的产品来源于不同交货单，请选择来源为同一交货单的产品 ！"
          });
          return;
        }
      });
      const h = this.$createElement;
      const tt = "请输入交货单号:【";
      this.$msgbox({
        title: `退货！`,
        message: h("div", null, [
          h(
              "span",
              null,
              tt
          ),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, `】以确认退货！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await shipmentOrderRecordBatchBack({
          id: _orderId,
          sn: this.batchDeviceSns
        });
        if (res.code == 0) {
          this.onSearch()
          this.$message({
            type: "success",
            message: "产品退货成功！"
          });
        }
      });
    },
    clickAllowSkip(row) {
      let tabPaneIds = this.$parent.tabPaneList2.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.$parent.tabPaneList2.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.$parent.tabPaneList2.push(row);
      }
    },
    async onSearch() {
      this.tableData = [];
      const res = await shipmentOrderRecordSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      });
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
</script>